var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_769_1",
    "data-name": "Component 769 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.192,
    height: 20,
    viewBox: "0 0 20.192 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    transform: "translate(0.022)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(-0.661 -2.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M10.757,20.215a10.188,10.188,0,0,1-7.385-3.6A16.618,16.618,0,0,1,.829,13.068l-.168-.335L.829,12.4A16.618,16.618,0,0,1,3.372,8.853a10.188,10.188,0,0,1,7.385-3.6,10.188,10.188,0,0,1,7.385,3.6A16.618,16.618,0,0,1,20.686,12.4l.168.335-.168.335a16.618,16.618,0,0,1-2.543,3.544A10.188,10.188,0,0,1,10.757,20.215Zm-8.4-7.483a15.866,15.866,0,0,0,2.138,2.882,8.61,8.61,0,0,0,6.264,3.1,8.609,8.609,0,0,0,6.264-3.1,15.866,15.866,0,0,0,2.138-2.882,15.866,15.866,0,0,0-2.138-2.882,8.609,8.609,0,0,0-6.264-3.1,8.609,8.609,0,0,0-6.264,3.1A15.866,15.866,0,0,0,2.355,12.733Z",
    transform: "translate(0 0)",
    fill: "#213960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M16.025,12.75a3.275,3.275,0,1,1-3.275,3.275A3.278,3.278,0,0,1,16.025,12.75Zm0,5.049a1.775,1.775,0,1,0-1.775-1.775A1.777,1.777,0,0,0,16.025,17.8Z",
    transform: "translate(-5.267 -3.292)",
    fill: "#213960"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.915b3528d0c41dc2dbd10afef5df4ca7.svg";
export { ForwardRef as ReactComponent };